var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v("如何填写发票内容？")]),_c('div',{staticClass:"content-info"},[_c('p',{staticClass:"txt1"},[_vm._v("\n      发票抬头：抬头要与营业执照注册名称一致\n      "),_c('br'),_vm._v("发票内容：内容必须与实际销售情况一致\n    ")])])])
}]

export { render, staticRenderFns }